<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard-products', params: { vendorId } }">
    <div class="vendor-deal-create">
      <crud-edit
        v-bind="editConfiguration"
        @item:updated="handleItemUpdated"></crud-edit>
    </div>
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CrudEdit from "@/client/components/crud/customV1/Edit.vue";
import vendorProductCreateFromConfigFactory from "@/client/applications/justopp/assets/static/forms/vendorProductFormFactory.js";
import Block from "@/client/components/base/frameworks/we/html/Block";
import { computed } from 'vue'

// TODO: backend: remember: assign owners, VendorId, other hard coded stuff
// TODO: add fields from excel sheet (plug, watt)
// TODO: load from older deals

export default {
  components: { Block, CrudEdit },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.vendorDealUpdate.pageTitle",
      subTitle: "justopp.vendorDealUpdate.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
    productId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.vendorDealUpdate.browserTitle",
  data() {

    return {
      editConfiguration: {
        itemId: this.productId,
        subject: "product",
        itemSrc: computed(() => "justopp/deals/" + this.productId),
        submitUrl: computed(() => {
          return "justopp/deals/" + this.productId;
        }), // default: shine/[name]
        showCancelButton: false,
        cancelRedirect: {
          name: "company-vendorId-dashboard-products",
          params: { vendorId: this.vendorId },
        },
        successRedirect: {
          name: "company-vendorId-dashboard-products",
          params: { vendorId: this.vendorId },
        },
        initialItemData: {
          VendorId: parseInt(this.vendorId),
          typeList: ["default", "justoppDeal", "auction"],
        },
        formConfig: vendorProductCreateFromConfigFactory({
          vendorId: this.vendorId,
          userProfile: this.$store.getters['user/profile'],
        }),
      },
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    //  this.productForm.adjustTypes([], true);
  },
  methods: {
    handleItemUpdated({ itemData }) {
      //  let targetTypes = Array.isArray(itemData.typeList) ? itemData.typeList : [];
      //  this.productForm.adjustTypes(targetTypes);
    },
  },
};
</script>

<style lang="scss">
.vendor-deal-create {
  .form {
    .fields {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .top-block {
        order: 100;
        flex: 0 0 100%;
      }
/*
      .form__fieldset {
        flex: 0 0 48%;

        @media (max-width: 1024px) {
          flex: 0 0 100%;
        }

        &.translations {
          flex: 0 0 100%;
        }
      }
      */
    }
  }
}
</style>

<style lang="scss" scoped></style>
